type SiteModalSorts = 'Message' | 'Image';

interface ISiteModal {
    sort: SiteModalSorts;
}

interface ISiteMessageModal
    extends ISiteModal {
    
    icon?: Icons;
    message?: string;
    buttons?: Array<ISiteActionButton>;
}

interface ISiteImageModal
    extends ISiteModal  {
    
    image: string;
    action?: IActionType;
}

class SiteModal
    extends QueryElement<HTMLElement> {
    
    constructor(obj: HTMLElement) {
        super(obj);

        this.on("click", () => {
            this.children().forEach((a) => a.remove());
            this.remove();
        });

    }

    show(card: ISiteCard, modal: ISiteModal) {
        this.removeClass("hide");

        if (modal.sort == "Message") {
            let messageModal = new SiteMessageModal(card, modal as ISiteMessageModal);
            this.append(messageModal);

            return messageModal;
        }
        if (modal.sort == "Image") {
            let imageModal = new SiteImageModal(card, modal as ISiteImageModal);
            this.append(imageModal);
            
            return imageModal;
        }
    }

    getModals() {
        return this.children();
    }

    async remove() {
        this.addClass("hide");
    }
}

class SiteMessageModal
    extends QueryElement<HTMLElement> {
    
    constructor(card: ISiteCard, modal: ISiteMessageModal) {
        super(document.createElement("DIV"));

        this.addClass("container");
        this.addClass("message");

        if (modal.icon !== undefined)
        this.append(
            QueryElement.QueryElement("i")
                .setHtml(modal.icon));

        if (modal.message !== undefined)
            this.append(
                QueryElement.QueryElement("div")
                    .addClass("content")
                    .setHtml(modal.message));

        if (modal.buttons !== undefined) {
            let buttons = QueryElement.QueryElement("div")
                .addClass("buttons")
                .appendTo(this);
            
            for (let button of modal.buttons) {
                let actionButton = new SiteActionButton(card, button);
                buttons.append(actionButton);
            }
        }
    }
}

class SiteImageModal
    extends QueryElement<HTMLElement> {
    
    private _action: SiteAction | null;
    
    constructor(card: ISiteCard, modal: ISiteImageModal) {
        super(document.createElement("DIV"));

        this.addClass("container");
        this.addClass("image");

        let action = SiteAction.create(card, modal.action);
        this._action = action;
        
        let element = QueryElement.QueryElement("img");
        element.on("click", () => {
            this.execute();
        });
        element.on("load", () => {
            let pos = QueryElement.get(document.body).position();
            let imagePos = element.position();
            
            if (pos == null || imagePos == null)
                return;

            let ratioWidth = imagePos.width / (pos.width - 50);
            let ratioHeight = imagePos.height / (pos.height - 50);

            let ratio = ratioWidth > ratioHeight ? ratioWidth : ratioHeight;
            ratio = ratio > 1 ? ratio : 1;

            element.setAttr("style", `width: ${imagePos.width/ratio}px; height: ${imagePos.height/ratio}px`)
        });
        element.setAttr("src", modal.image);

        this.append(element);
    }

    async execute() {
        await this._action?.execute();
    }
}